import React from "react";
import { getTripStatusUi } from "./tripUtils";

export default function BookingDetailsPopup({ bookingDetailsTrips, onClose }) {
  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <span>
            Booking Details
            {bookingDetailsTrips[0]?.paymentMethod
              ? ` - ${bookingDetailsTrips[0].paymentMethod}`
              : ""}
          </span>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="popup-body">
          {bookingDetailsTrips.map((trip, index) => {
            const { tabText, tabColor, isPastTrip } = getTripStatusUi(trip);

            const showFare =
              trip.paymentMethod !== "Invoice" &&
              trip.amountDue !== 0 &&
              (trip.paymentMethod === "Account" ||
                trip.paymentMethod === "Cash" ||
                (trip.paymentMethod === "Cash (On Outward)" && index === 0) ||
                (trip.paymentMethod === "Cash (On Return)" &&
                  index === bookingDetailsTrips.length - 1));

            return (
              <div key={trip.id} className="booking-trip-card">
                <div className="booking-trip-header">
                  <span title={trip.date}>
                    <strong>
                      {trip.formatteddate} at {trip.time}
                    </strong>
                  </span>
                </div>

                <div
                  className="booking-trip-icon"
                  style={{ backgroundColor: tabColor }}
                  title={isPastTrip ? `Past - ${trip.status}` : trip.status}
                >
                  {tabText}
                </div>

                <div className="booking-trip-body">
                  <p>
                    <strong>From:</strong> {trip.from.name}
                  </p>
                  <p>
                    <strong>To:</strong> {trip.to.name}
                  </p>
                  <p>
                    <strong>Aid:</strong> {trip.aid ?? "None"}
                  </p>

                  {showFare && (
                    <p>
                      <strong>Fare:</strong> £{Number(trip.fare).toFixed(2)}{" "}
                    </p>
                  )}

                  <p>
                    <strong>Status:</strong> {trip.status}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
